import { FilterItem, FilterState } from './filter.model'

/**
 * filter接口参数
 * @param filter
 * @returns
 */
export const fetchParams = (filter: FilterItem[]) => {
  const componentsConfig: any = window.NSComponentsConfig
  const obj: any = {}
  if (componentsConfig?.filter?.show) {
    if (filter && filter.length) {
      filter.forEach((item: FilterItem) => {
        if (item.filterState === FilterState.On) {
          const objSecond: any = {}
          item.options.forEach((itemSecond) => {
            const valueArr: string[] = []
            itemSecond.options.forEach((itemThird) => {
              if (itemThird.filterState === FilterState.On) {
                itemThird.value && valueArr.push(itemThird.value)
              }
            })
            valueArr?.length && (objSecond[itemSecond.key] = valueArr.join(','))
          })
          obj[item.key] = Object.keys(objSecond).length ? objSecond : null
        }
      })
    } else {
      const defaultItems = (componentsConfig?.filter?.properties?.items || '').split(',')
      defaultItems?.forEach((item: string) => {
        obj[item] = null
      })
    }
  } else {
    // 如果没有配置筛选项，则默认取defaultItems
    const defaultItems = (componentsConfig?.filter?.properties?.default_items || '').split(',')
    defaultItems?.forEach((item: string) => {
      obj[item] = null
    })
  }
  return obj
}

/**
 * 判断key在筛选中的状态
 * @param filter
 * @param key
 * @returns
 */
export const isFilterShowPowerSwap = (filter: FilterItem[]) => {
  const idx = filter.findIndex((item) => item.key === 'recharge|ps')
  if (idx === -1) {
    return false
  } else {
    if (filter[idx].filterState === FilterState.On) {
      return true
    } else if (filter.every((item) => item.filterState === FilterState.Off)) {
      return true
    } else {
      return false
    }
  }
}
